module.exports = __webpack_public_path__ + "static/media/whitelogo.4759256c.png";